module.exports = __webpack_public_path__ + "static/logotype-b1a6264b6b66f1b4686f70edfb6dbc20.svg";